module.exports = __webpack_public_path__ + "static/laundromatslider-06-min-84e92af65ad69d9613cf5de18a5568e2.jpg";